import { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

/**
 * InstallPrompt shows a floating button when the browser fires
 * beforeinstallprompt (Chrome/Edge on Android/desktop). On iOS Safari,
 * shows a small manual instructions banner.
 */
export default function InstallPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosBanner, setIosBanner] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("dbs_install_dismissed") === "1") return;
    if (localStorage.getItem("dbs_installed") === "1") return;

    const isStandalone = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
    if (isStandalone) {
      localStorage.setItem("dbs_installed", "1");
      return;
    }

    const onBip = (e) => {
      e.preventDefault();
      setDeferred(e);
      setVisible(true);
    };
    window.addEventListener("beforeinstallprompt", onBip);

    // iOS Safari doesn't fire beforeinstallprompt: show a manual hint
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isSafari = /^((?!chrome|android|crios|fxios).)*safari/i.test(navigator.userAgent);
    if (isIOS && isSafari) setIosBanner(true);

    return () => window.removeEventListener("beforeinstallprompt", onBip);
  }, []);

  const install = async () => {
    if (!deferred) return;
    deferred.prompt();
    const { outcome } = await deferred.userChoice;
    if (outcome === "accepted") localStorage.setItem("dbs_installed", "1");
    setDeferred(null);
    setVisible(false);
  };

  const dismiss = () => {
    localStorage.setItem("dbs_install_dismissed", "1");
    setVisible(false);
    setIosBanner(false);
  };

  if (visible) {
    return (
      <div
        className="fixed bottom-4 right-4 z-50 flex items-center gap-3 p-3 border shadow-lg"
        style={{ background: "var(--surface)", borderColor: "var(--primary)", maxWidth: 340 }}
        data-testid="install-prompt"
      >
        <img src="/dbs-logo.jpeg" alt="DBS FIELD" className="w-10 h-10 object-cover" style={{ borderRadius: 2 }} />
        <div className="flex-1 min-w-0">
          <div style={{ fontFamily: "Chivo", fontWeight: 700, fontSize: 13 }}>Instalar DBS FIELD</div>
          <div className="text-xs" style={{ color: "var(--text-dim)" }}>Acesso rápido direto do celular</div>
        </div>
        <button className="btn btn-primary" onClick={install} data-testid="install-btn"><Download size={13} /> Instalar</button>
        <button className="btn btn-ghost" onClick={dismiss} data-testid="install-dismiss"><X size={13} /></button>
      </div>
    );
  }

  if (iosBanner) {
    return (
      <div
        className="fixed bottom-4 left-4 right-4 z-50 p-3 border text-xs"
        style={{ background: "var(--surface)", borderColor: "var(--primary)", color: "var(--text-dim)" }}
        data-testid="install-ios-banner"
      >
        <div className="flex items-start gap-2">
          <div className="flex-1">
            <b style={{ color: "var(--text)" }}>Instalar no iPhone:</b> toque no botão de <b>Compartilhar</b> do Safari e escolha <b>Adicionar à Tela de Início</b>.
          </div>
          <button className="btn btn-ghost" onClick={dismiss}><X size={13} /></button>
        </div>
      </div>
    );
  }

  return null;
}
